import {
    getStowAssociateMetrics,
    getStowBinMetrics,
    getStowCartMetrics,
    getStowPackageMetrics
} from "../resources/StowResource";
import {getInductPackageMetrics} from "../resources/InductResource";
import {publishCount, publishTime} from "../MetricUtility";
import {CYCLE, CYCLE_ID, ERROR_METRIC_SUFFFIX, FALSE, TOTAL, True} from "../constants";
import {AssociateMetric, InductPackageMetric, StowPackageMetric, Resource, BinMetric, CartMetric} from "../enums";

export const LOAD_METRICS_FOR_CLUSTER_CALL_BEGIN = "LOAD_METRICS_FOR_CLUSTER_CALL_BEGIN";
export const LOAD_STOW_PACKAGE_METRICS_FOR_CLUSTER = "LOAD_STOW_PACKAGE_METRICS_FOR_CLUSTER";
export const LOAD_STOW_BIN_METRICS_FOR_CLUSTER = "LOAD_STOW_BIN_METRICS_FOR_CLUSTER";
export const LOAD_STOW_CART_METRICS_FOR_CLUSTER = "LOAD_STOW_CART_METRICS_FOR_CLUSTER";
export const LOAD_INDUCT_PACKAGE_METRICS_FOR_CLUSTER = "LOAD_INDUCT_PACKAGE_METRICS_FOR_CLUSTER";
export const LOAD_STOW_BIN_METRICS_FOR_NODE = "LOAD_STOW_BIN_METRICS_FOR_NODE";
export const LOAD_STOW_ASSOCIATE_METRICS_FOR_CLUSTER = "LOAD_STOW_ASSOCIATE_METRICS_FOR_CLUSTER";
export const LOAD_STOW_PACKAGE_METRICS_FOR_NODE = "LOAD_STOW_PACKAGE_METRICS_FOR_NODE";
export const LOAD_STOW_CART_METRICS_FOR_NODE = "LOAD_STOW_CART_METRICS_FOR_NODE";
export const LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE = "LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE";
export const LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE = "LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE";
export const LOAD_METRICS_FOR_CLUSTER_CALL_FAILURE = "LOAD_METRICS_FOR_CLUSTER_CALL_FAILURE";

const metricProcessName = "SCC_STOW_CLUSTER";

const loadMetricsForClusterCallBegin = () => ({
    type: LOAD_METRICS_FOR_CLUSTER_CALL_BEGIN
});

const loadStowPackageMetricsForCluster = (stowPackageMetricsMap) => ({
    type: LOAD_STOW_PACKAGE_METRICS_FOR_CLUSTER,
    stowPackageMetricsMap
});

const loadStowCartMetricsForCluster = (stowCartMetricsMap) => ({
    type: LOAD_STOW_CART_METRICS_FOR_CLUSTER,
    stowCartMetricsMap
});

const loadStowCartMetricsForNode = (totalStowCartMetricsMap) => ({
    type: LOAD_STOW_CART_METRICS_FOR_NODE,
    totalStowCartMetricsMap
});

const loadStowBinMetricsForCluster = (stowBinMetricsMap) => ({
    type: LOAD_STOW_BIN_METRICS_FOR_CLUSTER,
    stowBinMetricsMap
});

const loadStowBinMetricsForNode = (totalStowBinMetrics) => ({
    type: LOAD_STOW_BIN_METRICS_FOR_NODE,
    totalStowBinMetrics
});

const loadInductPackageMetricsForCluster = (inductPackageMetricsMap) => ({
    type: LOAD_INDUCT_PACKAGE_METRICS_FOR_CLUSTER,
    inductPackageMetricsMap
});

const loadStowAssociateMetricsForCluster = (stowAssociateMetricsMap) => ({
    type: LOAD_STOW_ASSOCIATE_METRICS_FOR_CLUSTER,
    stowAssociateMetricsMap
});

const loadStowPackageMetricsForNode = (totalStowPackageMetrics) => ({
    type: LOAD_STOW_PACKAGE_METRICS_FOR_NODE,
    totalStowPackageMetrics
});

const loadInductPackageMetricsForNode = (totalInductPackageMetrics) => ({
    type: LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE,
    totalInductPackageMetrics
});

const loadStowAssociateMetricsForNode = (totalStowAssociateMetrics) => ({
    type: LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE,
    totalStowAssociateMetrics
});

const loadMetricsForClusterCallFailure = () => ({
    type: LOAD_METRICS_FOR_CLUSTER_CALL_FAILURE
});

export const getStowPackageMetricsForCluster =
    (isADTAVisibilityEnabled, isDRSStowVisibilityEnabled, nodeId, cycles, cycleIds) => {

    const metricName = "getStowPackageMetrics";

    const request = {
        groupBy: Resource.CLUSTER,
        filters: {
            NODE: [nodeId]
        },
        metrics: [
            StowPackageMetric.STOW_RATE,
            StowPackageMetric.SCAN_COMPLIANCE,
            StowPackageMetric.PROBLEM_SOLVE_COUNT,
            StowPackageMetric.PLANNED_COUNT,
            StowPackageMetric.STOW_VS_PLAN,
            StowPackageMetric.STOWED_COUNT,
            StowPackageMetric.CURRENT_INDUCTED_COUNT
        ],
        isAggregationRequired: true
    }
    if (!isDRSStowVisibilityEnabled) {
        request.filters["DRS"] = [FALSE]
    }

    if (isADTAVisibilityEnabled) {
        request.metrics.push(StowPackageMetric.CURRENT_STOW_BUFFERED_COUNT)
        request.metrics.push(StowPackageMetric.CURRENT_MFR_JACKPOT_BUFFERED_COUNT)
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length) {
        request.filters[CYCLE_ID] = cycleIds;
    }

    function getStowPackageMetricsForNode(stowPackageMetricsMap) {
        return {Total: stowPackageMetricsMap[TOTAL]}
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForClusterCallBegin());
            const startTime = Date.now();
            const stowPackageMetricsMap = await getStowPackageMetrics(request);
            if (stowPackageMetricsMap) {
                dispatch(loadStowPackageMetricsForNode(getStowPackageMetricsForNode(stowPackageMetricsMap)));
                removeUnwantedClusters(stowPackageMetricsMap);
                dispatch(loadStowPackageMetricsForCluster(stowPackageMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForClusterCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForClusterCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getStowBinMetricsForCluster = (nodeId, cycles, cycleIds) => {

    const metricName = "getStowBinMetrics";

    const request = {
        groupBy: Resource.CLUSTER,
        filters: {
            NODE: [nodeId]
        },
        metrics: [BinMetric.BINS_COUNT_MISSING_OPEN_BAG]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length) {
        request.filters[CYCLE_ID] = cycleIds;
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForClusterCallBegin());
            const startTime = Date.now();
            const stowBinMetricsMap = await getStowBinMetrics(request);
            if (stowBinMetricsMap) {
                removeUnwantedClusters(stowBinMetricsMap);
                dispatch(loadStowBinMetricsForNode(getTotalMetrics(stowBinMetricsMap)));
                dispatch(loadStowBinMetricsForCluster(stowBinMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForClusterCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForClusterCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getStowCartMetricsForCluster = (nodeId, cycles, cycleIds, isStowBreakdownV2Enabled) => {
    const metricName = "getStowCartMetrics";
    const request = {
        groupBy: Resource.CLUSTER,
        filters: {
            NODE: [nodeId]
        },
        metrics: [
            CartMetric.PLANNED_CART_COUNT,
            CartMetric.OPEN_CART_COUNT,
            CartMetric.MISSING_CART_COUNT
        ]
    }

    if (isStowBreakdownV2Enabled) {
        request.filters["STOW_BREAKDOWN_V2"] = [True]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length) {
        request.filters[CYCLE_ID] = cycleIds;
    }

    function getStowCartMetricsForNode(stowCartMetricsMap) {
        return {Total: stowCartMetricsMap[TOTAL]}
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForClusterCallBegin());
            const startTime = Date.now();
            const stowCartMetricsMap = await getStowCartMetrics(request);
            if (stowCartMetricsMap) {
                dispatch(loadStowCartMetricsForNode(getStowCartMetricsForNode(stowCartMetricsMap)));
                removeUnwantedClusters(stowCartMetricsMap);
                dispatch(loadStowCartMetricsForCluster(stowCartMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForClusterCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForClusterCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getInductPackageMetricsForCluster = (nodeId, cycles) => {

    const metricName = "getInductPackageMetrics";

    const request = {
        nodeId: nodeId,
        groupBy: "Cluster",
        metricList: [InductPackageMetric.RECEIVED]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters = {Cycle: cycles}
    }
    return async (dispatch) => {
        try {
            dispatch(loadMetricsForClusterCallBegin());
            const startTime = Date.now();
            const inductPackageMetricsMap = await getInductPackageMetrics(request);
            if (inductPackageMetricsMap) {
                removeUnwantedClusters(inductPackageMetricsMap);
                dispatch(loadInductPackageMetricsForNode(getTotalMetrics(inductPackageMetricsMap)));
                dispatch(loadInductPackageMetricsForCluster(inductPackageMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForClusterCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForClusterCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getStowAssociateMetricsForCluster = (nodeId, cycles) => {

    const metricName = "getStowAssociateMetrics";

    const request = {
        groupBy: Resource.CLUSTER,
        filters: {
            NODE: [nodeId]
        },
        metrics: [
            AssociateMetric.ACTIVE_ASSOCIATE_COUNT,
            AssociateMetric.INACTIVE_ASSOCIATE_COUNT
        ]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters[CYCLE] = cycles;
    }
    return async (dispatch) => {
        try {
            dispatch(loadMetricsForClusterCallBegin());
            const startTime = Date.now();
            const stowAssociateMetricsMap = await getStowAssociateMetrics(request);
            if (stowAssociateMetricsMap) {
                removeUnwantedClusters(stowAssociateMetricsMap);
                dispatch(loadStowAssociateMetricsForNode(getTotalMetrics(stowAssociateMetricsMap)));
                dispatch(loadStowAssociateMetricsForCluster(stowAssociateMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForClusterCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForClusterCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getInductPackageMetricsForNode = (nodeId, cycles) => {
    const request = {
        nodeId: nodeId,
        groupBy: "Node",
        metricList: ["INDUCTED_AT_STATION", "PENDING_INDUCT"]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters = {"Cycle": cycles}
    }
    return async (dispatch) => {
        try {
            dispatch(loadMetricsForClusterCallBegin());
            const inductPackageMetricsMap = await getInductPackageMetrics(request);
            replaceNodeByTotal(inductPackageMetricsMap, nodeId);
            if (inductPackageMetricsMap) {
                dispatch(loadInductPackageMetricsForNode(inductPackageMetricsMap));
            } else {
                dispatch(loadMetricsForClusterCallFailure());
            }
        } catch (error) {
            dispatch(loadMetricsForClusterCallFailure());
        }
    }
}

export const getStowAssociateMetricsForNode = (nodeId, cycles) => {
    const request = {
        groupBy: "NODE",
        filters: {
            'NODE': [nodeId]
        },
        metrics: ["ACTIVE_ASSOCIATE_COUNT", "INACTIVE_ASSOCIATE_COUNT"]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters["CYCLE"] = cycles;
    }
    return async (dispatch) => {
        try {
            dispatch(loadMetricsForClusterCallBegin());
            const stowAssociateMetricsMap = await getStowAssociateMetrics(request);
            replaceNodeByTotal(stowAssociateMetricsMap, nodeId);
            if (stowAssociateMetricsMap) {
                dispatch(loadStowAssociateMetricsForNode(stowAssociateMetricsMap));
            } else {
                dispatch(loadMetricsForClusterCallFailure());
            }
        } catch (error) {
            dispatch(loadMetricsForClusterCallFailure());
        }
    }
}

function replaceNodeByTotal(metricsMap, nodeId) {
    metricsMap["Total"] = metricsMap[nodeId];
    delete metricsMap[nodeId];
}

function getTotalMetrics(groupedMetricsMap) {
    const totalCluster = {};
    for (const cluster in groupedMetricsMap) {
        const metricsMap = groupedMetricsMap[cluster];

        for (const metric in metricsMap) {
            if (!totalCluster[metric]) {
                totalCluster[metric] = metricsMap[metric];
            } else {
                totalCluster[metric] = +totalCluster[metric] + +metricsMap[metric];
            }
        }
    }

    return {Total: totalCluster};
}

function removeUnwantedClusters(metricsMap) {
    delete metricsMap[TOTAL];
}


// WEBPACK FOOTER //
// ./src/actions/ClusterActions.js